export function mapRfm(status) {
  const map = {
    champion: {
      color: "#FDA712",
      textColor: "#FFFBED",
      name: "Campeão",
      icon: "ui-trophy-01",
    },
    loyal: {
      color: "#0B9055",
      textColor: "#FFFBED",
      name: "Leal",
      icon: "ui-heart",
    },
    potential_champion: {
      color: "#D3F8E0",
      textColor: "#0B9055",
      name: "Potencial Leal",
      icon: "ui-thumbs-up",
    },
    needs_attention: {
      color: "#FB6E15",
      textColor: "#FFFBED",
      name: "Atenção",
      icon: "ui-alert-square",
    },
    about_to_sleep: {
      color: "#FFE2CF",
      textColor: "#FB6E15",
      name: "Prestes a dormir",
      icon: "ui-clock-snooze",
    },
    promising: {
      color: "#D9E5FF",
      textColor: "#2970FF",
      name: "Promissor",
      icon: "ui-face-smile",
    },
    new: {
      color: "#2970FF",
      textColor: "#FFFBED",
      name: "Novo",
      icon: "ui-stars-02",
    },
    hibernating: {
      color: "#6C737F",
      textColor: "#FFFBED",
      name: "Hibernando",
      icon: "ui-clock-snooze",
    },
    at_risk: {
      color: "#FEF3F2",
      textColor: "#F04438",
      name: "Em Risco",
      icon: "ui-alert-triangle",
    },
    lost: {
      color: "#1F2A37",
      textColor: "#FFFBED",
      name: "Perdido",
      icon: "ui-x-square",
    },
    cant_lose: {
      color: "#F04438",
      textColor: "#FFFBED",
      name: "Não Pode Perder",
      icon: "ui-slash-circle-01",
    },
  };

  return (
    map[status] || {
      color: "#E5E7EB",
      textColor: "#FFFBED",
      name: "",
      icon: "ui-minus",
    }
  );
}
export function mapEvent(event_type, params = {}) {
  const map = {
    feedback: {
      name: "Feedback recebido",
      color: "#BFF3CC",
      textColor: "#209941",
    },

    coupon_generated: {
      name: "Cupom gerado",
      color: "#BFF3CC",
      textColor: "#209941",
      icon: "ui-plus-circle",
    },

    coupon_used: {
      name: "Cupom utilizado",
      color: "#BFF3CC",
      textColor: "#209941",
      icon: "ui-coins-swap-01",
    },

    earned_points: {
      name: params.points > 0 ? "Pontos ganhos" : "Pontos perdidos",
      color: params.points > 0 ? "#BFF3CC" : "#FEE4E2",
      textColor: params.points > 0 ? "#209941" : "#DE3024",
      icon: params.points > 0 ? "ui-plus-circle" : "ui-minus-circle",
    },

    rescued_reward: {
      name: "Recompensa resgatada",
      color: "#BFF3CC",
      textColor: "#209941",
      icon: "ui-coins-swap-01",
    },

    "custom-event": {
      name: "Evento personalizado",
      color: "#BFF3CC",
      textColor: "#209941",
      icon: "ui-flag-01",
    },

    segment: {
      name: params.action == "left" ? "Saiu do segmento" : "Entrou no segmento",
      color: "#E5E7EB",
      textColor: "#6C737F",
      icon: "ui-tag-02",
    },

    order: {
      name: "Pedido",
      color: ["cancelled"].includes(params.status) ? "#FEE4E2" : "#BFF3CC",
      textColor: ["cancelled"].includes(params.status) ? "#DE3024" : "#209941",
      icon: "ui-currency-dollar",
    },

    quotation: {
      name: "Orçamento",
      color: ["expired", "rejected"].includes(params.status)
        ? "#FEE4E2"
        : "#E5E7EB",
      textColor: ["expired", "rejected"].includes(params.status)
        ? "#DE3024"
        : "#6C737F",
      icon: "ui-file-05",
    },

    "task-completed": {
      name: "Tarefa Concluída",
      color: "#BFF3CC",
      textColor: "#209941",
      icon: "ui-check",
    },

    sms: {
      name: "SMS",
      color: "#BFF3CC",
      textColor: "#209941",
      icon: "ui-message-text-square-01",
    },

    rcs: {
      name: "RCS",
      color: params.status == "failed" ? "#FEE4E2" : "#BFF3CC",
      textColor: params.status == "failed" ? "#DE3024" : "#209941",
      icon: "ui-message-notification-square",
    },

    email: {
      name: "E-mail",
      color: params.status == "failed" ? "#FEE4E2" : "#BFF3CC",
      textColor: params.status == "failed" ? "#DE3024" : "#209941",
      icon: "ui-mail-01",
    },

    whatsapp: {
      name: "Mensagem (WhatsApp)",
      color: params.status == "failed" ? "#FEE4E2" : "#BFF3CC",
      textColor: params.status == "failed" ? "#DE3024" : "#209941",
      customIcon: "far fa-whatsapp",
    },

    "whatsapp-cloud": {
      name:
        params.status == "failed"
          ? "Falha no envio (WhatsApp Cloud)"
          : "Mensagem enviada (WhatsApp Cloud)",
      color: params.status == "failed" ? "#FEE4E2" : "#BFF3CC",
      textColor: params.status == "failed" ? "#DE3024" : "#209941",
      customIcon: "far fa-whatsapp",
    },

    "campaign-interaction": {
      name:
        params.channel === "phonetrack"
          ? "Ligação realizada"
          : "Interação em campanha",
      color: "#E5E7EB",
      textColor: "#6C737F",
      icon:
        params.channel === "phonetrack"
          ? "ui-phone-call-01"
          : "ui-cursor-click-01",
    },

    "task-created": {
      name: "Tarefa criada",
      color: "#BFF3CC",
      textColor: "#209941",
      icon: "ui-plus-circle",
    },

    "ai-action": {
      name: params.result_success ? "IA executada" : "IA falhou",
      color: params.result_success ? "#E8DBFF" : "#FEE4E2",
      textColor: params.result_success ? "#7C3AED" : "#DE3024",
      icon: "ui-stars-02",
    },

    "field-update": {
      name:
        params.status == "failed"
          ? "Falha ao atualizar campo"
          : "Campo atualizado",
      color: params.status == "failed" ? "#FEE4E2" : "#BFF3CC",
      textColor: params.status == "failed" ? "#DE3024" : "#209941",
      icon: params.status == "failed" ? "ui-alert-triangle" : "ui-check",
    },
  };

  return (
    map[event_type] || {
      name: "Evento desconhecido",
      color: "#E5E7EB",
      textColor: "#6C737F",
      icon: "ui-minus",
    }
  );
}
